import { ConfirmationDialog } from '@/components/Common/ConfirmationDialog/ConfirmationDialog';
import { useGlobalContext } from '@/context/Global/GlobalContext';
import { useDeleteProduct } from '@/hooks/product/catalog/useDeleteProduct';
import { useDisableProduct } from '@/hooks/product/catalog/useDisableProduct';
import { useEnableProduct } from '@/hooks/product/catalog/useEnableProduct';
import { DashboardUserType } from '@/utils/enums';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { ProductUi } from './ProductUi';

export function ContextualMenu(props: { product: ProductUi }) {
  const { session } = useGlobalContext();
  const isAdmin = session?.type === DashboardUserType.ADMIN;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const enableProductHook = useEnableProduct();
  const disableProductHook = useDisableProduct();
  const deleteProductHook = useDeleteProduct();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openDialog, setOpenDialog] = useState(false);

  const confirmDeleteProduct = () => {
    deleteProductHook.mutate({
      productId: props.product.productId,
      productSku: props.product.skuId,
    });
    setOpenDialog(false);
    handleClose();
  };

  const confirmCancelAction = () => {
    handleClose();
    setOpenDialog(false);
  };

  return (
    <>
      <IconButton
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          event.preventDefault();
          setAnchorEl(event.currentTarget);
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {props.product.status?.statusId === 'unpublished' && (
          <MenuItem
            onClick={() => {
              enableProductHook.mutate({
                productId: props.product.productId,
                productSku: props.product.skuId,
              });
              handleClose();
            }}
          >
            Publicar
          </MenuItem>
        )}

        {props.product.status?.statusId === 'published' && (
          <MenuItem
            onClick={() => {
              disableProductHook.mutate({
                productId: props.product.productId,
                productSku: props.product.skuId,
              });
              handleClose();
            }}
          >
            Desactivar
          </MenuItem>
        )}
        {isAdmin && (
          <MenuItem
            onClick={() => {
              setOpenDialog(true);
            }}
          >
            Borrar
          </MenuItem>
        )}
      </Menu>
      <ConfirmationDialog
        open={openDialog}
        title="Confirmación"
        message={'El producto será borrado. ¿Deseas continuar?'}
        okButton={{ label: 'Aceptar', variant: 'contained' }}
        onOkButtonListener={confirmDeleteProduct}
        koButton={{ label: 'Cancelar', variant: 'outlined' }}
        onKoButtonListener={confirmCancelAction}
        cancelable
      />
    </>
  );
}
